import styled from 'styled-components';

const LocalContainer = styled.div``;

export { LocalContainer };
